<template>
  <div>
    <div
      class="nav-drawer"
      :style="windowWidth < 1264 ? '' : 'max-height: 90vh;'"
    >
      <v-navigation-drawer
        v-model="mapControls"
        v-if="mapDataLoaded && !collectionMode"
        width="300"
        hide-overlay
        v-show="mapControls"
      >
        <v-list>
          <!-- Legend -->
          <v-list-group>
            <template v-slot:activator value="true">
              <v-list-tile>
                <v-list-tile-title><b>Legend</b></v-list-tile-title>
              </v-list-tile>
            </template>
            <v-divider></v-divider>
            <v-list-tile>
              <v-list-tile-title>{{
                currentRiparianLayer.name
              }}</v-list-tile-title>
            </v-list-tile>
            <v-list-tile
              v-for="(item, index) in currentRiparianLayerOptions"
              :key="index"
            >
              <v-list-tile-action>
                <v-icon :color="legendColor(index)">lens</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{ item }}</v-list-tile-title>
            </v-list-tile>
            <v-divider></v-divider>
            <v-list-tile>
              <v-list-tile-action>
                <v-img
                  :src="require('@/assets/images/star.png')"
                  height="20"
                  contain
                ></v-img>
              </v-list-tile-action>
              <v-list-tile-title>Projects on the Ground</v-list-tile-title>
            </v-list-tile>
          </v-list-group>
        </v-list>

        <v-list>
          <!-- map controls -->
          <v-list-group>
            <template v-slot:activator value="true">
              <v-list-tile>
                <v-list-tile-title><b>Map & Tools</b></v-list-tile-title>
              </v-list-tile>
            </template>
            <v-list>
              <v-list-group prepend-icon="layers" :value="layersToggle">
                <template v-slot:activator>
                  <v-list-tile>
                    <v-list-tile-title>Map Layers</v-list-tile-title>
                  </v-list-tile>
                </template>
                <v-list-group no-action sub-group :value="basemapToggle">
                  <template v-slot:activator>
                    <v-list-tile>
                      <v-list-tile-title>Basemaps</v-list-tile-title>
                    </v-list-tile>
                  </template>

                  <v-list-tile
                    v-for="(item, i) in baseMaps"
                    :key="i"
                    @click="activateBaseMap(item)"
                  >
                    <v-list-tile-title v-text="item.name"></v-list-tile-title>
                    <v-list-tile-action>
                      <v-icon>{{
                        item.name === baseLayer
                          ? "radio_button_checked"
                          : "radio_button_unchecked"
                      }}</v-icon>
                    </v-list-tile-action>
                  </v-list-tile>
                </v-list-group>

                <v-list-group sub-group no-action>
                  <template v-slot:activator>
                    <v-list-tile>
                      <v-list-tile-title>Layers</v-list-tile-title>
                    </v-list-tile>
                  </template>
                  <v-list-tile
                    v-for="(layer, i) in baseLayers"
                    :key="i"
                    @click="activateBaseLayer(layer)"
                    avatar
                  >
                    <v-list-tile-title v-text="layer.name"></v-list-tile-title>
                    <v-list-tile-action>
                      <v-icon>{{
                        layer.toggled
                          ? "radio_button_checked"
                          : "radio_button_unchecked"
                      }}</v-icon>
                    </v-list-tile-action>
                  </v-list-tile>
                </v-list-group>
              </v-list-group>

              <v-list-group
                prepend-icon="eco"
                :value="riparianToggle"
                no-action
                v-if="authenticated"
              >
                <template v-slot:activator>
                  <v-list-tile>
                    <v-list-tile-title>Riparian Layers</v-list-tile-title>
                  </v-list-tile>
                </template>

                <!-- POG toggle -->
                <v-list-tile @click="togglePogView()">
                  <v-list-tile-title>Projects on the Ground</v-list-tile-title>
                  <v-list-tile-action>
                    <v-icon>{{
                      pogsToggled
                        ? "radio_button_checked"
                        : "radio_button_unchecked"
                    }}</v-icon>
                  </v-list-tile-action>
                </v-list-tile>

                <v-list-tile
                  v-for="(item, i) in riparianLayers"
                  :key="i"
                  @click="toggleLayer(item)"
                >
                  <v-list-tile-title v-text="item.name"></v-list-tile-title>
                  <v-list-tile-action>
                    <v-icon>{{
                      item.name === currentRiparianLayer.name
                        ? "radio_button_checked"
                        : "radio_button_unchecked"
                    }}</v-icon>
                  </v-list-tile-action>
                </v-list-tile>
              </v-list-group>

              <v-list-tile @click="$emit('toggle-pog')" v-if="authenticated">
                <v-list-tile-action>
                  <v-icon>add_location</v-icon>
                </v-list-tile-action>
                <v-list-tile-title>Projects on the Ground</v-list-tile-title>
              </v-list-tile>

              <v-list-group prepend-icon="bubble_chart" :value="toolsToggle">
                <template v-slot:activator>
                  <v-list-tile>
                    <v-list-tile-title>Tools</v-list-tile-title>
                  </v-list-tile>
                </template>
                <v-list-tile @click="$router.push({ name: 'spatial-stats' })">
                  <v-list-tile-title>Summary Tool</v-list-tile-title>
                </v-list-tile>
              </v-list-group>
            </v-list>
          </v-list-group>
        </v-list>
      </v-navigation-drawer>
    </div>
    <div id="map" class="map">
      <!-- Search -->
      <v-btn
        class="search-button"
        color="white"
        @click="searchBar = !searchBar"
        prepend-icon="search"
        depressed
        >advanced search
      </v-btn>
      <v-navigation-drawer v-model="searchBar" right fixed temporary>
        <search
          :pogs="pogs"
          @fly-to-marker="flyToMarker"
          @close="searchBar = false"
        ></search>
      </v-navigation-drawer>

      <v-avatar
        v-show="windowWidth < 1264 && !mapControls"
        class="map-control-button"
        color="primary"
        @click="mapControls = true"
        elevation-10
      >
        <v-icon dark>menu</v-icon>
      </v-avatar>

      <v-progress-circular
        v-if="!mapDataLoaded"
        indeterminate
        size="200"
        color="info"
        class="progress-spinner"
      >
        <h4 class="text-lg-center">Please wait</h4>
      </v-progress-circular>

      <div v-if="collectionMode" class="map-buttons text-lg-center">
        <v-card elevation="10">
          <v-progress-linear indeterminate size="20"></v-progress-linear>
          <v-subheader>Project Location</v-subheader>
          <v-card-text>
            Click on the map or enter a location
            <v-text-field
              label="Latitude"
              v-model="customLatitude"
              dense
              type="number"
            ></v-text-field>
            <v-text-field
              label="Longitude"
              v-model="customLongitude"
              dense
              type="number"
            ></v-text-field>
            <v-layout justify-center align-center>
              <v-flex sm6>
                <v-btn
                  @click="submitCoords()"
                  flat
                  dense
                  v-if="customLatitude && customLongitude"
                  >submit</v-btn
                >
              </v-flex>
              <v-flex sm6>
                <v-btn @click="cancelCoords()" flat dense color="warning"
                  >cancel</v-btn
                >
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import Search from "@/components/map/Search.vue";
import * as mapboxgl from "mapbox-gl";
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
import "mapbox-gl/dist/mapbox-gl.css";
import { getPOGCoverPhoto } from "@/api/map";

export default {
  name: "RiparianMap",

  components: {
    Search,
  },

  props: {
    collectCoordinates: Boolean,
  },

  data() {
    return {
      map: null,
      pogsToggled: true,
      layersToggle: false,
      basemapToggle: false,
      watershedToggle: false,
      riparianToggle: false,
      toolsToggle: false,

      mapControls: true,
      windowWidth: window.innerWidth,
      searchBar: false,
      noAuthZoom: 11,
      clickedCoords: { lat: null, lng: null },
      clickedPOG: null,
      baseLayer: "Streets",
      currentRiparianLayer: null,

      infoLayer: null,

      collectionMode: false,
      customLatitude: null,
      customLongitude: null,

      mapOptions: {
        container: "map",
        style: "mapbox://styles/mapbox/streets-v11",
        center: [-114, 55],
        zoom: 5,
        maxZoom: 11,
      },

      intactnessPallette: ["#f54242", "#eba834", "#daed09", "#45f542"],

      pressurePallette: [
        "rgb(70, 41, 130)",
        "rgb(109, 66, 145)",
        "rgb(191, 188, 217)",
      ],

      conservationPriorityPallette: [
        "rgb(111, 56, 26)",
        "rgb(187, 156, 113)",
        "rgb(189, 236, 109)",
        "rgb(61, 122, 43)",
      ],

      huc2MapHover: null,
      huc6MapHover: null,
    };
  },

  computed: {
    authenticated() {
      return this.$store.state.settings.authenticated;
    },
    mapDataLoaded() {
      return this.$store.state.map.dataLoaded;
    },
    pogs() {
      return this.$store.state.map.pogs;
    },
    baseMaps() {
      return this.$store.state.map.baseMaps;
    },
    baseLayers() {
      return this.$store.state.map.baseLayers;
    },
    pallette() {
      const name = this.currentRiparianLayer.name;
      return name.includes("Intactness")
        ? this.intactnessPallette
        : name.includes("Prioritization")
        ? this.conservationPriorityPallette
        : this.pressurePallette;
    },
    riparianLayers() {
      let layers = this.$store.state.map.riparianLayers;
      if (!this.authenticated) {
        layers = layers.filter((lyr) => {
          return lyr.public;
        });
      }

      return layers;
    },
    currentRiparianLayerOptions() {
      if (this.currentRiparianLayer.options.length > this.pallette.length) {
        let options = [];
        for (let i = 0; i < this.currentRiparianLayer.options.length; i += 2) {
          options.push(this.currentRiparianLayer.options[i]);
        }
        return options;
      } else return this.currentRiparianLayer.options;
    },
    huc2() {
      return this.$store.state.map.spatialStatsWatersheds[0];
    },
    huc6() {
      return this.$store.state.map.spatialStatsWatersheds[1];
    },
  },

  watch: {
    collectCoordinates(val) {
      if (val) {
        // Set up a click event
        this.collectionMode = true;
        this.map.on("click", this.collectClick);
      }
    },

    authenticated(newVal) {
      if (this.map) this.changeMapPermissions(newVal);
    },

    pogs() {
      this.addPOGPoints();
    },

    $route(to) {
      // Hacky way to activate the POG form
      if (to.path === "/riparian/dummy") {
        this.$emit("pog-from-click", this.clickedCoords);
        this.$router.push("/riparian");
      } else if (to.path === "/riparian/dummy2") {
        this.$emit("pog-view", this.clickedPOG);
        this.$router.push("/riparian");
      }
    },
  },

  methods: {
    legendColor(i) {
      if (this.currentRiparianLayer.options.length === 3) {
        if (i === 3) return this.pallette[4];
        else return this.pallette[i];
      } else return this.pallette[i];
    },

    createPalletteExpression(field_name, options) {
      let expression = ["match", ["get", field_name]];

      const pallette =
        field_name === "Intactness"
          ? this.intactnessPallette
          : field_name === "Prioritization"
          ? this.conservationPriorityPallette
          : this.pressurePallette;

      let palletteValues;
      if (options.length === 3 && pallette.length > 3) {
        palletteValues = [pallette[0], pallette[2], pallette[3]];
      } else palletteValues = pallette;

      if (options.length === palletteValues.length * 2) {
        let optI = 0;
        for (let i = 0; i < palletteValues.length; i++) {
          expression.push(options[optI], palletteValues[i]);
          optI += 2;
        }
        optI = 1;
        for (let i = 0; i < palletteValues.length; i++) {
          expression.push(options[optI], palletteValues[i]);
          optI += 2;
        }
      } else {
        let i;
        for (i = 0; i < palletteValues.length; i++) {
          expression.push(options[i], palletteValues[i]);
        }
      }

      expression.push("rgba(0,0,0,0)");

      return expression;
    },

    async initMap() {
      // Ensure data are available
      if (!this.mapDataLoaded) {
        setTimeout(this.initMap, 200);
        return;
      }

      // Initiate the map instance
      mapboxgl.accessToken = this.$store.state.map.mapbox_gl_token;

      if (this.map) {
        this.map.remove();
        this.map = null;
      }

      this.map = new mapboxgl.Map(this.mapOptions);

      this.map.addControl(
        new MapboxGeocoder({
          accessToken: mapboxgl.accessToken,
          mapboxgl: mapboxgl,
        })
      );

      if (this.authenticated) this.map.setMaxZoom(null);
      this.map.addControl(
        new mapboxgl.NavigationControl("bottom-right"),
        "bottom-right"
      );

      // Initiate layers on load
      this.map.on("load", () => {
        // Add custom layers
        this.addLayers();

        this.map.on("style.load", () => {
          this.addLayers();
        });
      });
    },

    addLayers() {
      let firstSymbolId;
      let layers = this.map.getStyle().layers;
      for (let i = 0; i < layers.length; i++) {
        if (layers[i].type === "symbol") {
          firstSymbolId = layers[i].id;
          break;
        }
      }
      // Add a hillshade
      this.map.addSource("dem", {
        type: "raster-dem",
        url: "mapbox://mapbox.terrain-rgb",
      });
      this.map.addLayer(
        {
          id: "dem-hillshade",
          source: "dem",
          type: "hillshade",
          maxzoom: 13,
        },
        firstSymbolId
      );

      // Watersheds - HUC 6
      this.map.addSource(this.huc6.mapID, {
        type: "vector",
        tiles: [this.huc6.url],
      });
      this.huc6.paint["fill-opacity"] = [
        "case",
        ["boolean", ["feature-state", "hover"], false],
        0.15,
        0,
      ];
      this.huc6.paint["fill-color"] = "#000000";
      this.map.addLayer(
        {
          id: this.huc6.mapID,
          type: "fill",
          source: this.huc6.mapID,
          "source-layer": this.huc6.layer,
          paint: this.huc6.paint,
          minzoom: 7,
          maxzoom: 10,
        },
        firstSymbolId
      );
      this.map.addLayer(
        {
          id: `${this.huc6.mapID}-boundary`,
          type: "line",
          source: this.huc6.mapID,
          "source-layer": this.huc6.layer,
          minzoom: 7,
          paint: {
            "line-color": "#3b0b57",
            "line-width": 1,
          },
        },
        firstSymbolId
      );
      this.map.addLayer({
        id: `${this.huc6.mapID}-labels`,
        type: "symbol",
        source: this.huc6.mapID,
        "source-layer": this.huc6.layer,
        minzoom: 7,
        layout: {
          "text-field": ["get", this.huc6.nameField],
        },
        paint: {
          "text-color": "#fff",
          "text-halo-color": "black",
          "text-halo-width": 1,
          "text-opacity": [
            "case",
            ["boolean", ["feature-state", "hover"], false],
            1,
            0,
          ],
        },
      });
      this.map.on("mousemove", this.huc6.mapID, (e) => {
        if (e.features.length > 0) {
          this.map.getCanvas().style.cursor = "pointer";
          if (this.huc6MapHover !== null) {
            if (!this.dataLoaded) {
              this.map.setFeatureState(
                {
                  source: this.huc6.mapID,
                  sourceLayer: this.huc6.layer,
                  id: this.huc6MapHover,
                },
                { hover: false }
              );
            }
          }
          this.huc6MapHover = e.features[0].id;
          this.map.setFeatureState(
            {
              source: this.huc6.mapID,
              sourceLayer: this.huc6.layer,
              id: this.huc6MapHover,
            },
            { hover: true }
          );
        }
      });
      this.map.on("mouseleave", this.huc6.mapID, () => {
        this.map.getCanvas().style.cursor = "";
        if (!this.dataLoaded) {
          this.map.setFeatureState(
            {
              source: this.huc6.mapID,
              sourceLayer: this.huc6.layer,
              id: this.huc6MapHover,
            },
            { hover: false }
          );
        }
        this.huc6MapHover = null;
      });

      // Watersheds - HUC 2
      this.map.addSource(this.huc2.mapID, {
        type: "vector",
        tiles: [this.huc2.url],
      });
      this.huc2.paint["fill-opacity"] = [
        "case",
        ["boolean", ["feature-state", "hover"], false],
        0.15,
        0,
      ];
      this.huc2.paint["fill-color"] = "#000000";
      this.map.addLayer(
        {
          id: this.huc2.mapID,
          type: "fill",
          source: this.huc2.mapID,
          "source-layer": this.huc2.layer,
          paint: this.huc2.paint,
          maxzoom: 7,
        },
        firstSymbolId
      );
      this.map.addLayer(
        {
          id: `${this.huc2.mapID}-boundary`,
          type: "line",
          source: this.huc2.mapID,
          "source-layer": this.huc2.layer,
          paint: {
            "line-color": "#3b0b57",
            "line-width": 2,
          },
        },
        firstSymbolId
      );
      this.map.addLayer({
        id: `${this.huc2.mapID}-labels`,
        type: "symbol",
        source: this.huc2.mapID,
        "source-layer": this.huc2.layer,
        maxzoom: 7,
        layout: {
          "text-field": ["get", this.huc2.nameField],
        },
        paint: {
          "text-color": "#fff",
          "text-halo-color": "black",
          "text-halo-width": 1,
          "text-opacity": [
            "case",
            ["boolean", ["feature-state", "hover"], false],
            1,
            0,
          ],
        },
      });
      this.map.on("mousemove", this.huc2.mapID, (e) => {
        if (e.features.length > 0) {
          this.map.getCanvas().style.cursor = "pointer";
          if (this.huc2MapHover !== null) {
            if (!this.dataLoaded) {
              this.map.setFeatureState(
                {
                  source: this.huc2.mapID,
                  sourceLayer: this.huc2.layer,
                  id: this.huc2MapHover,
                },
                { hover: false }
              );
            }
          }
          this.huc2MapHover = e.features[0].id;
          this.map.setFeatureState(
            {
              source: this.huc2.mapID,
              sourceLayer: this.huc2.layer,
              id: this.huc2MapHover,
            },
            { hover: true }
          );
        }
      });
      this.map.on("mouseleave", this.huc2.mapID, () => {
        this.map.getCanvas().style.cursor = "";
        if (!this.dataLoaded) {
          this.map.setFeatureState(
            {
              source: this.huc2.mapID,
              sourceLayer: this.huc2.layer,
              id: this.huc2MapHover,
            },
            { hover: false }
          );
        }
        this.huc2MapHover = null;
      });

      this.map.on("click", this.huc2.mapID, (e) => {
        this.fitMapBounds(e.features[0].geometry.coordinates);
      });

      // Riparian Layers
      this.riparianLayers.forEach((lyr) => {
        let paint = lyr.paint;
        if (lyr.type === "line")
          paint["line-color"] = this.createPalletteExpression(
            lyr.field_options[0],
            lyr.options
          );
        else
          paint["fill-color"] = this.createPalletteExpression(
            lyr.field_options[0],
            lyr.options
          );

        let layout = lyr.layout;
        layout.visibility =
          lyr.name === this.currentRiparianLayer.name ? "visible" : "none";
        this.map.addSource(lyr.name, {
          type: "vector",
          tiles: [lyr.url],
        });
        this.map.addLayer(
          {
            id: lyr.name,
            type: lyr.type,
            source: lyr.name,
            "source-layer": lyr.layer,
            layout: layout,
            paint: paint,
            minzoom: 7,
          },
          firstSymbolId
        );

        // Cursor
        this.map.on("mouseenter", lyr.name, () => {
          this.map.getCanvas().style.cursor = "pointer";
        });

        // Change it back to a pointer when it leaves.
        this.map.on("mouseleave", lyr.name, () => {
          this.map.getCanvas().style.cursor = "";
        });

        // Click events
        this.map.on("click", lyr.name, (e) => {
          this.clickedCoords = e.lngLat;

          const properties = e.features[0].properties;

          let lat = Math.round(e.lngLat.lat * 1000) / 1000;
          let lng = Math.round(e.lngLat.lng * 1000) / 1000;

          let popupHTML = `<b>Lat:</b> ${lat}<br><b>Lng:</b> ${lng}<br>`;
          popupHTML += this.authenticated
            ? '<a href="/#/riparian/dummy">Create a Project on the Ground</a><br><br>'
            : "";
          Object.keys(properties).forEach((key) => {
            popupHTML += `<b>${key}:</b> ${properties[key]}<br>`;
          });
          popupHTML += `<b>Lat:</b> ${lat}<br><b>Lng:</b> ${lng}`;

          new mapboxgl.Popup({
            anchor: "bottom",
          })
            .setLngLat(e.lngLat)
            .setHTML(popupHTML)
            .addTo(this.map);
        });
      });

      this.map.addSource("pogs", {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
      });

      this.map.loadImage(
        require("@/assets/images/star.png"),
        (error, image) => {
          if (error) throw error;
          this.map.addImage("star", image);

          this.map.addLayer({
            id: "pogs",
            type: "symbol",
            source: "pogs",
            layout: {
              "icon-image": "star",
              "icon-size": 0.04,
              "icon-allow-overlap": true,
            },
          });
        }
      );

      // Add POG data
      this.addPOGPoints();

      this.map.on("mouseenter", "pogs", () => {
        this.map.getCanvas().style.cursor = "pointer";
      });

      // Change it back to a pointer when it leaves.
      this.map.on("mouseleave", "pogs", () => {
        this.map.getCanvas().style.cursor = "";
      });

      // POGS events
      this.map.on("click", "pogs", (e) => {
        this.clickedPOG = e.features[0].properties.id;

        let pogID = e.features[0].properties.id;
        let pog = this.pogs.filter((pog) => {
          return `${pog.createdByUser} ${pog.id}` === pogID;
        })[0];

        let name =
          pog.name.length > 36 ? pog.name.slice(0, 36) + "..." : pog.name;
        let description =
          pog.description.length > 36
            ? pog.description.slice(0, 36) + "..."
            : pog.description;

        // Collect a templink
        const showPopup = async () => {
          let imgTag;
          if (pog.photos.length > 0) {
            // Collect the first photo
            imgTag = `<img style="background:url(https://s3.us-west-2.amazonaws.com/riparian.info/public/logo_notext.png) center no-repeat;" loading="lazy" src=${await getPOGCoverPhoto(
              pog
            )} alt="Photo" width="220">`;
          } else {
            imgTag =
              '<img style="display: block; margin-left: auto; margin-right: auto; width: 50%;" src="https://s3.us-west-2.amazonaws.com/riparian.info/public/logo_notext.png" alt="Photos" width="60">';
          }

          const popupHTML = `<span>${name}</span><br><a href="/#/riparian/dummy2">${imgTag}</a><br>${description}<br><b><a href="/#/riparian/dummy2">View Project</a></b>`;

          new mapboxgl.Popup()
            .setLngLat(e.lngLat)
            .setHTML(popupHTML)
            .addTo(this.map);
        };

        showPopup();
      });

      // Base Layers
      this.baseLayers.forEach((baseLayer) => {
        if (baseLayer.url) {
          this.map.addSource(baseLayer.name, {
            type: "vector",
            tiles: [baseLayer.url],
          });
          if (!baseLayer.noGeo) {
            this.map.addLayer(
              {
                id: baseLayer.name,
                type: baseLayer.type,
                source: baseLayer.name,
                "source-layer": baseLayer.sourceLayer,
                layout: {
                  visibility: baseLayer.toggled ? "visible" : "none",
                },
                paint: baseLayer.paint,
              },
              firstSymbolId
            );
          }
          if (baseLayer.labels) {
            this.map.addLayer({
              id: `${baseLayer.name}-labels`,
              type: "symbol",
              source: baseLayer.name,
              "source-layer": baseLayer.sourceLayer,
              layout: {
                "text-field": ["get", baseLayer.labelField],
                visibility: baseLayer.toggled ? "visible" : "none",
                "text-padding": 50,
                ...(baseLayer.labelLayout ? baseLayer.labelLayout : {}),
              },
              paint: {
                "text-halo-color": "#fff",
                "text-halo-width": 1,
                ...(baseLayer.labelPaint ? baseLayer.labelPaint : {}),
              },
            });
          }
        }
      });
    },

    togglePogView() {
      this.map.setLayoutProperty(
        "pogs",
        "visibility",
        this.pogsToggled ? "none" : "visible"
      );
      this.pogsToggled = !this.pogsToggled;
    },

    flyToMarker(coords, zoom) {
      // new mapboxgl.Marker().setLngLat(coords).addTo(this.map);
      this.map.flyTo({
        center: coords,
        zoom: zoom,
      });
    },

    activateBaseMap(layer) {
      if (layer.name !== this.baseLayer) {
        this.baseLayer = layer.name;
        this.map.setStyle(layer.value);
      }
    },

    activateBaseLayer(layer) {
      this.$store.commit("map/toggleBaseLayer", layer.name);

      // Custom logic for watersheds
      if (layer.name === "Watersheds") {
        [this.huc2.mapID, this.huc6.mapID].forEach((ws) => {
          this.map.setLayoutProperty(
            ws,
            "visibility",
            layer.toggled ? "visible" : "none"
          );
          this.map.setLayoutProperty(
            `${ws}-boundary`,
            "visibility",
            layer.toggled ? "visible" : "none"
          );
          this.map.setLayoutProperty(
            `${ws}-labels`,
            "visibility",
            layer.toggled ? "visible" : "none"
          );
        });
      } else {
        if (!layer.noGeo) {
          this.map.setLayoutProperty(
            layer.name,
            "visibility",
            layer.toggled ? "visible" : "none"
          );
        }
        if (layer.labels) {
          this.map.setLayoutProperty(
            `${layer.name}-labels`,
            "visibility",
            layer.toggled ? "visible" : "none"
          );
        }
      }
    },

    toggleLayer(layer) {
      if (layer.name !== this.currentRiparianLayer.name) {
        this.map.setLayoutProperty(
          this.currentRiparianLayer.name,
          "visibility",
          "none"
        );
        this.currentRiparianLayer = layer;
        this.map.setLayoutProperty(layer.name, "visibility", "visible");
      }
    },

    changeMapPermissions(auth) {
      this.initMap();
      if (!auth) {
        this.currentRiparianLayer = this.riparianLayers[0];
      }
    },

    collectClick(e) {
      this.customLatitude = Math.round(e.lngLat.lat * 1000) / 1000;
      this.customLongitude = Math.round(e.lngLat.lng * 1000) / 1000;
    },

    cancelCoords() {
      this.collectionMode = false;
      this.map.off("click", this.collectClick);
      this.$emit("coordinates-collected", null);
    },

    submitCoords() {
      this.collectionMode = false;
      this.map.off("click", this.collectClick);
      this.$emit("coordinates-collected", {
        lat: this.customLatitude,
        lng: this.customLongitude,
      });
    },

    addPOGPoints() {
      if (!this.pogs || !this.map) return;
      let data = [];
      this.pogs.forEach((pog) => {
        data.push({
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [pog.coordinates.lng, pog.coordinates.lat],
          },
          properties: {
            id: `${pog.createdByUser} ${pog.id}`,
          },
        });
      });

      if (data.length === 0) {
        data = [
          {
            type: "Feature",
            geometry: {
              type: "Point",
              coordinates: [],
            },
            properties: {
              id: 0,
            },
          },
        ];
      }

      let source = this.map.getSource("pogs");
      if (source) {
        source.setData({
          type: "FeatureCollection",
          features: data,
        });
      }
    },

    fitMapBounds(coords) {
      let coordinates = [];
      const nextCoords = (coords) => {
        if (coords.length > 2) {
          coords.forEach((coord) => nextCoords(coord));
        } else {
          coordinates = [coords, ...coordinates];
        }
      };
      coords.forEach((coord) => nextCoords(coord));

      let bounds = coordinates.reduce((bounds, coord) => {
        return bounds.extend(coord);
      }, new mapboxgl.LngLatBounds(coordinates[0], coordinates[0]));

      this.map.fitBounds(bounds, {
        padding: 40,
      });
    },
  },

  mounted() {
    window.addEventListener("resize", () => {
      this.windowWidth = window.innerWidth;
    });
    this.currentRiparianLayer = this.riparianLayers[0];
    this.initMap();
  },
};
</script>

<style scoped>
.map {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}
.map-buttons {
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 1;
}
.button-size {
  min-width: 130px;
  font-size: 10px;
}
.legend-buttons {
  font: revert;
  min-width: 60px;
  padding-left: 0;
  padding-right: 0;
}
.progress-spinner {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  z-index: 11;
}
.gradient-legend {
  padding: 10px;
  max-width: 200px;
}
.search-button {
  position: absolute;
  top: 50px;
  right: 0px;
  cursor: pointer;
  z-index: 2;
  width: 240px;
}
.map-control-button {
  position: absolute;
  top: 20px;
  left: 20px;
  cursor: pointer;
  z-index: 2;
}
.legend-padding {
  padding: 5px;
}
.legend {
  margin: auto;
  right: 10px;
}
.legend h4 {
  margin: 0 0 10px;
}

.legend div span {
  border-radius: 50%;
  display: inline-block;
  height: 10px;
  margin-right: 5px;
  width: 10px;
}
.nav-drawer {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 1;
  overflow: auto;
}
</style>
